import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/subscriptions")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Subscriptions")),
  head: () => ({ meta: seo({ title: "Subscriptions" }) }),
});
